import { useState, useEffect } from 'react';
import api from '../api';
import { MODULES } from '../modules';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ full_name: '', email: '', password: '', is_admin: false, modules: [] });
  const [loading, setLoading] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  const fetchUsers = async () => {
    try {
      const res = await api.get('/api/users/');
      setUsers(res.data);
    } catch {
      alert('Kullanıcılar yüklenemedi');
    }
  };

  useEffect(() => { fetchUsers(); }, []);

  const resetForm = () => {
    setForm({ full_name: '', email: '', password: '', is_admin: false, modules: [] });
    setEditUser(null);
    setShowForm(false);
  };

  const handleEdit = (user) => {
    setEditUser(user);
    setForm({ full_name: user.full_name, email: user.email, password: '', is_admin: user.is_admin, modules: user.modules || [] });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editUser) {
        const payload = {
          full_name: form.full_name,
          is_admin: form.is_admin,
          modules: form.modules,
        };
        if (form.password) payload.password = form.password;
        await api.put(`/api/users/${editUser.id}`, payload);
      } else {
        if (!form.password) { alert('Şifre zorunludur'); setLoading(false); return; }
        await api.post('/api/users/', form);
      }
      fetchUsers();
      resetForm();
    } catch (err) {
      alert('Hata: ' + JSON.stringify(err.response?.data?.detail || 'Bilinmeyen hata'));
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActive = async (user) => {
    try {
      await api.put(`/api/users/${user.id}`, { is_active: !user.is_active });
      fetchUsers();
    } catch (err) {
      alert('Hata: ' + JSON.stringify(err.response?.data?.detail));
    }
  };

  const handleDelete = async (user) => {
    if (!window.confirm(`"${user.full_name}" kullanıcısı silinecek. Emin misiniz?`)) return;
    try {
      await api.delete(`/api/users/${user.id}`);
      fetchUsers();
    } catch (err) {
      alert('Hata: ' + JSON.stringify(err.response?.data?.detail));
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Kullanıcı Yönetimi</h2>
        <button onClick={() => { resetForm(); setShowForm(true); }}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium">
          + Yeni Kullanıcı
        </button>
      </div>

      {showForm && (
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h3 className="font-semibold text-gray-700 mb-4">
            {editUser ? `Kullanıcı Düzenle — ${editUser.full_name}` : 'Yeni Kullanıcı'}
          </h3>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ad Soyad *</label>
                <input required value={form.full_name}
                  onChange={e => setForm({...form, full_name: e.target.value})}
                  className="w-full border rounded px-3 py-2" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                <input required type="email" value={form.email}
                  onChange={e => setForm({...form, email: e.target.value})}
                  disabled={!!editUser}
                  className={`w-full border rounded px-3 py-2 ${editUser ? 'bg-gray-100 text-gray-500' : ''}`} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Şifre {editUser ? '(boş bırakılırsa değişmez)' : '*'}
                </label>
                <input type="password" value={form.password}
                  onChange={e => setForm({...form, password: e.target.value})}
                  className="w-full border rounded px-3 py-2"
                  placeholder={editUser ? 'Değiştirmek için girin' : ''} />
              </div>
              <div className="flex items-center gap-3 pt-6">
                <input type="checkbox" id="is_admin" checked={form.is_admin}
                  onChange={e => setForm({...form, is_admin: e.target.checked})}
                  className="w-4 h-4" />
                <label htmlFor="is_admin" className="text-sm font-medium text-gray-700">
                  Admin yetkisi ver
                </label>
              </div>
              {!form.is_admin && (
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Erişebileceği modüller</label>
                  <div className="grid grid-cols-3 gap-2">
                    {MODULES.map(m => (
                      <label key={m.key} className="flex items-center gap-2 text-sm text-gray-700">
                        <input type="checkbox" className="w-4 h-4"
                          checked={form.modules.includes(m.key)}
                          onChange={e => setForm({...form, modules: e.target.checked
                            ? [...form.modules, m.key]
                            : form.modules.filter(k => k !== m.key)})} />
                        {m.label}
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="flex gap-3 mt-4">
              <button type="submit" disabled={loading}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 font-medium disabled:opacity-50">
                {loading ? 'Kaydediliyor...' : editUser ? 'Güncelle' : 'Ekle'}
              </button>
              <button type="button" onClick={resetForm}
                className="bg-gray-100 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-200 font-medium">
                İptal
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Ad Soyad</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Email</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Yetki</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Durum</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Kayıt Tarihi</th>
              <th className="text-center px-6 py-3 text-sm font-medium text-gray-500">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {users.map(u => (
              <tr key={u.id} className={`hover:bg-gray-50 ${!u.is_active ? 'opacity-50' : ''}`}>
                <td className="px-6 py-4 font-medium text-gray-800">
                  {u.full_name}
                  {u.id === currentUser.id && <span className="ml-2 text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded">Siz</span>}
                </td>
                <td className="px-6 py-4 text-gray-600 text-sm">{u.email}</td>
                <td className="px-6 py-4">
                  {u.is_admin
                    ? <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded font-medium">Admin</span>
                    : <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded font-medium">
                        Kullanıcı ({(u.modules || []).length}/{MODULES.length} modül)
                      </span>}
                </td>
                <td className="px-6 py-4">
                  {u.is_active
                    ? <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded font-medium">Aktif</span>
                    : <span className="text-xs bg-gray-100 text-gray-500 px-2 py-1 rounded font-medium">Pasif</span>}
                </td>
                <td className="px-6 py-4 text-gray-500 text-sm">
                  {new Date(u.created_at).toLocaleDateString('tr-TR')}
                </td>
                <td className="px-6 py-4 text-center whitespace-nowrap">
                  <button onClick={() => handleEdit(u)}
                    className="text-blue-600 hover:text-blue-800 font-medium text-xs px-2 py-1 rounded hover:bg-blue-50">
                    ✏️ Düzenle
                  </button>
                  {u.id !== currentUser.id && (
                    <>
                      <button onClick={() => handleToggleActive(u)}
                        className={`font-medium text-xs px-2 py-1 rounded ${u.is_active ? 'text-orange-600 hover:bg-orange-50' : 'text-green-600 hover:bg-green-50'}`}>
                        {u.is_active ? '⏸ Pasif Yap' : '▶️ Aktif Yap'}
                      </button>
                      <button onClick={() => handleDelete(u)}
                        className="text-red-500 hover:text-red-700 font-medium text-xs px-2 py-1 rounded hover:bg-red-50">
                        🗑 Sil
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && (
          <div className="text-center py-12 text-gray-400">Kullanıcı bulunamadı</div>
        )}
      </div>
    </div>
  );
}
